import React, { useState, useRef, useEffect } from 'react'
import './ShippingPreference.css'
import { useHistory } from 'react-router-dom'
import { getPostcodeMatriceByPostcode } from '../../../../api'
import { useEffectOnce } from 'react-use'
import { nonSpecialCharRegex, SHIPPING_TYPES } from '../../../../../utils'

const ShippingPreference = (props: any) => {
    const { setPostCode, isCustomerPortal = false, email } = props
    const history = useHistory()

    /**
     * RADIO BUTTONS
     */
    const [selectedShipping, setSelectedShipping] = useState(
        localStorage.getItem('selectedShipping') || SHIPPING_TYPES.BNE
    )
    const handleShippingChange = (event: any) => {
        setSelectedShipping(event.target.value)
        sessionStorage.removeItem('cartItems')
    }
    /**
     *POSTAL CODE
     */
    const postCodeRef = useRef<any>()
    const [errorMsg, setErrorMsg] = useState<string | undefined>()

    const isDelivery = selectedShipping === SHIPPING_TYPES.DELIVERY



    useEffectOnce(() => {
        const localShippingStorage = localStorage.getItem('shipping-preference')
        if (localShippingStorage) {
            const localShipping = JSON.parse(localShippingStorage)
            if (localShipping.postalCode && postCodeRef.current) {
                postCodeRef.current.value = localShipping.postalCode
            }
        }
    })

    const handleSavePreference = async () => {
        setErrorMsg(undefined)
        let redirect = isCustomerPortal ? '/customer/quick-order?tab=Panels' : '/quick-order?tab=Panels';
        const postCodeValue = postCodeRef.current && postCodeRef.current.value
        let shippingPreference: any = {
            postalCode: postCodeValue,
            shipping: selectedShipping,
        }
        if (postCodeValue) {
            var postCode: any = await getPostcodeMatriceByPostcode(postCodeValue)

            if (postCode.data && postCode.data.pricebook && postCodeValue.length === 4) {
                shippingPreference = {
                    ...shippingPreference,
                    pricebookId: postCode.data.pricebookId,
                    deliveryFee: postCode.data.deliveryFee,
                    state: postCode.data.state,
                    country: 'Australia'
                }
            } else {
                redirect += '&state=1'
                shippingPreference = {
                    ...shippingPreference,
                    pricebookId: postCode.data.pricebookId,
                    deliveryFee: 'TBC',
                }
            }
        } else {
            shippingPreference = {
                ...shippingPreference,
                pricebookId: selectedShipping == SHIPPING_TYPES.BNE ? 1 : 2,
                deliveryFee: '0',
            }
        }

        localStorage.setItem('shipping-preference', JSON.stringify(shippingPreference))

        setPostCode(postCode?.data?.postCode)
        localStorage.setItem('customer-info', JSON.stringify(customer))

        history.push(redirect)
        window.location.reload()
    }

    useEffect(() => {
        localStorage.setItem('selectedShipping', selectedShipping)
    }, [selectedShipping])

    const customerInfo = localStorage.getItem('customer-info')
    const defaultCustomer = {
        firstName: '',
        lastName: '',
        companyName: '',
        contact: '',
        email: '',
        address1: '',
        address2: '',
        suburb: '',
        state: '',
        postCode: '',
        country: 'Australia'
    }

    let initialCustomer = defaultCustomer
    if (customerInfo) {
        initialCustomer = JSON.parse(customerInfo)
    }
    var [customer, setCustomer] = useState(initialCustomer)

    const handleInputChange = async (event: any) => {
        const { name, value } = event.target
        setCustomer((prevCustomer: any) => ({
            ...prevCustomer,
            [name]: value,
        }))
    }

    return (
        <div className='tab-items'>
            {/* TOAST */}
            {errorMsg ? (
                <div className='alert alert-danger w-25 m-auto text-center' role='alert'>
                    {errorMsg}
                </div>
            ) : null}
            <form
                onSubmit={(e) => {
                    e.preventDefault()
                    handleSavePreference()
                }}
            >
                <div className='form-group'>
                    <div className='d-flex justify-content-between'>
                        <p>How would you want to get your Order?</p>
                        <button type='submit' className='btn btn-primary'>
                            NEXT
                        </button>
                    </div>

                    <div className='row'>
                        <div className='col-md-3'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='radio'
                                    name='shipping'
                                    id={SHIPPING_TYPES.BNE}
                                    value={SHIPPING_TYPES.BNE}
                                    checked={selectedShipping === SHIPPING_TYPES.BNE}
                                    onChange={handleShippingChange}
                                />
                                <label className='form-check-label' htmlFor={SHIPPING_TYPES.BNE}>
                                    Customer Collect (BNE)
                                </label>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='radio'
                                    name='shipping'
                                    id={SHIPPING_TYPES.SYD}
                                    value={SHIPPING_TYPES.SYD}
                                    checked={selectedShipping === SHIPPING_TYPES.SYD}
                                    onChange={handleShippingChange}
                                />
                                <label className='form-check-label' htmlFor={SHIPPING_TYPES.SYD}>
                                    Customer Collect (SYD)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 30, marginBottom: 30 }}>
                        <div className='form-check'>
                            <input
                                className='form-check-input'
                                type='radio'
                                name='shipping'
                                id={SHIPPING_TYPES.DELIVERY}
                                value={SHIPPING_TYPES.DELIVERY}
                                checked={selectedShipping === SHIPPING_TYPES.DELIVERY}
                                onChange={handleShippingChange}
                            />
                            <label className='form-check-label' htmlFor={SHIPPING_TYPES.DELIVERY}>
                                Delivery
                            </label>
                        </div>
                        {selectedShipping === SHIPPING_TYPES.DELIVERY ? (<>                            
                            <div className='row mb-6' style={{ height: 80 }}>
                                <div className='col'>
                                    <div className='form-outline'>
                                        <label className='fw-bolder text-dark' htmlFor='address1'>
                                            Address
                                            {isDelivery && customer.address1.trim() === '' && (
                                                <small style={{ color: '#f00' }}>*</small>
                                            )}
                                        </label>
                                        <input
                                            style={{ fontSize: '1rem' }}
                                            type='text'
                                            id='address1'
                                            className='form-control'
                                            placeholder='Address 1'
                                            name='address1'
                                            value={customer.address1}
                                            onChange={handleInputChange}
                                            {...(isDelivery === true ? { required: true } : { disabled: true })}
                                        />
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='form-outline'>
                                        <label
                                            className='fw-bolder text-dark'
                                            htmlFor='address1'
                                        >
                                            Address 2
                                        </label>
                                        <input
                                            style={{ fontSize: '1rem' }}
                                            type='text'
                                            id='address2'
                                            className='form-control'
                                            placeholder='Address 2 (optional)'
                                            name='address2'
                                            value={customer.address2}
                                            onChange={handleInputChange}
                                            {...(isDelivery === true ? {} : { disabled: true })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='row mb-6' style={{ height: 80 }}>
                                <div className='col'>
                                    <div className='form-outline'>
                                        <label className='fw-bolder text-dark' htmlFor='suburb'>
                                            Suburb
                                            {isDelivery && customer.suburb.trim() === '' && (
                                                <small style={{ color: '#f00' }}>*</small>
                                            )}
                                        </label>
                                        <input
                                            style={{ fontSize: '1rem' }}
                                            type='text'
                                            id='suburb'
                                            className='form-control'
                                            placeholder='Suburb'
                                            name='suburb'
                                            value={customer.suburb}
                                            onChange={handleInputChange}
                                            {...(isDelivery === true ? { required: true } : { disabled: true })}
                                        />
                                        {nonSpecialCharRegex.test(customer.suburb) && (
                                            <small style={{ color: '#f00' }}>Special characters not allowed.</small>
                                        )}
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='form-outline'>
                                        <label className='fw-bolder text-dark' htmlFor='postCode'>
                                            Post Code
                                            {isDelivery && customer.postCode.trim() === '' && (
                                                <small style={{ color: '#f00' }}>*</small>
                                            )}
                                        </label>
                                        <input
                                            style={{ fontSize: '1rem' }}
                                            ref={postCodeRef}
                                            type='text'
                                            id='postCode'
                                            className='form-control'
                                            placeholder='Postcode'
                                            name='postCode'
                                            value={customer.postCode}
                                            onChange={handleInputChange}
                                            maxLength={4}
                                            {...(isDelivery === true ? { required: true } : null)}
                                        />
                                        {/* {isDelivery &&customer.postCode !== '' && !/^\d{4}$/.test(customer.postCode) && (
                                            <small style={{ color: '#f00' }}>Invalid Australian Post code format. </small>
                                        )}
                                        {isDelivery && !isServiceable && customer.postCode !== '' && (
                                            <small style={{ color: '#f00' }}>Area is not serviceable</small>
                                        )} */}
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='form-outline'>
                                        <label className='fw-bolder text-dark' htmlFor='state'>
                                            State
                                            {isDelivery && customer.state.trim() === '' && (
                                                <small style={{ color: '#f00' }}>*</small>
                                            )}
                                        </label>
                                        <input
                                            style={{ fontSize: '1rem' }}
                                            type='text'
                                            id='state'
                                            className='form-control'
                                            placeholder='State'
                                            name='state'
                                            value={customer.state}
                                            onChange={handleInputChange}
                                            {...(isDelivery === true ? { required: true } : null)}
                                        />
                                        {nonSpecialCharRegex.test(customer.state) && (
                                            <small style={{ color: '#f00' }}>Special characters not allowed.</small>
                                        )}
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='form-outline'>
                                        <label className='fw-bolder text-dark' htmlFor='country'>
                                            Country
                                        </label>
                                        <input
                                            style={{ fontSize: '1rem' }}
                                            type='text'
                                            id='country'
                                            className='form-control'
                                            placeholder='Country'
                                            name='country'
                                            value={customer.country}
                                            onChange={handleInputChange}
                                            readOnly
                                            {...(isDelivery === true ? { required: true } : { disabled: true })}
                                        />
                                        {nonSpecialCharRegex.test(customer.country) && (
                                            <small style={{ color: '#f00' }}>Special characters not allowed.</small>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>) : null}
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ShippingPreference
